var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1944_7555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9961 0V3.05176C24.9149 3.54112 30.4589 9.08506 30.9482 16.0039H34V17.9961H30.9482C30.4589 24.9149 24.9149 30.4589 17.9961 30.9482V34H16.0039V30.9482C9.08506 30.4589 3.54112 24.9149 3.05176 17.9961H0V16.0039H3.05176C3.54112 9.08506 9.08506 3.54112 16.0039 3.05176V0H17.9961ZM17.9961 6.65527H16.0039V5.0498C10.1842 5.53067 5.53067 10.1842 5.0498 16.0039H6.65527V17.9961H5.0498C5.53067 23.8158 10.1842 28.4693 16.0039 28.9502V27.3447H17.9961V28.9502C23.8158 28.4693 28.4693 23.8158 28.9502 17.9961H27.3447V16.0039H28.9502C28.4693 10.1842 23.8158 5.53067 17.9961 5.0498V6.65527ZM17 8.9209C21.4549 8.92096 25.0791 12.5451 25.0791 17C25.079 21.4548 21.4548 25.079 17 25.0791C12.5451 25.0791 8.92096 21.4549 8.9209 17C8.9209 12.5451 12.5451 8.9209 17 8.9209ZM17 10.9131C13.6436 10.9131 10.9131 13.6436 10.9131 17C10.9131 20.3564 13.6436 23.0869 17 23.0869C20.3563 23.0869 23.0869 20.3563 23.0869 17C23.0869 13.6436 20.3564 10.9131 17 10.9131Z",
    fill: "#5F5F6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1944_7555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.d823937d9e4b7854e186b369065ab530.svg";
export { ForwardRef as ReactComponent };